export default __webpack_public_path__ + "static/media/preneumerate_img3.ae83baf8.png";